import React from 'react';
import classNames from 'classnames';

import { capitalize } from '@lib/helpers';

import * as styles from './styles.module.scss';
import BackgroundImageContainer from '../BackgroundImageContainer';

const ContentWell = (props) => {
  const {
    backgroundSize = null,
    banner,
    children,
    className,
    hideBackgroundMobile,
    inline,
    secondary: secondaryRaw = false,
    size: sizeRaw = 'cat',
    reverseBackground,
    theme,
    tighten,
    withBackground,
  } = props;
  const size = capitalize(sizeRaw);
  const secondary = withBackground ? true : secondaryRaw;

  return (
    <BackgroundImageContainer
      className={classNames(styles.background, withBackground && styles.withBackground)}
      hideBackgroundMobile={hideBackgroundMobile}
      reverse={reverseBackground}
      size={backgroundSize}
      theme={theme}
    >
      <div
        className={classNames(styles.layout, secondary && styles.secondary, className)}
      >
        <div
          className={classNames(
            styles.content,
            size && styles[`size${size}`],
            tighten && styles.tighten
          )}
        >
          <div className={classNames(styles.banner, inline && styles.inline)}>
            {banner}
          </div>
          {children}
        </div>
      </div>
    </BackgroundImageContainer>
  );
};

export default ContentWell;
